module.exports = __webpack_public_path__ + "static/media/user-icon-white.d2868be5.svg";